import { getLocale } from "../runtime";

const sv_filanguage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Suomi`
};

const filanguage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_filanguage(inputs)
	return "fiLanguage";
};

export { filanguage as "fiLanguage" };